import React, { useState } from "react";
import './AMSEssentials.css';

function AMS() {
    const [readMore, setReadMore] = useState(false);
    const [readMore2, setReadMore2] = useState(false);

    return (
        <>
            <div className="overall-container">
                <div className="inner-box-container">
                    <img src={process.env.PUBLIC_URL + "/images/Monarch/AMS/CoreConcept.png"} alt="" className="tile-img" />
                    <img src={process.env.PUBLIC_URL + "/images/Monarch/AMS/week2.png"} alt="" className="week-img" />
                    <h3 className="course-heading">AMS - Core Concepts</h3>
                    <p className="course-desc">This SME lead training will enable you to gain a deeper understanding of Application Management concepts through practical, real-time scenarios. The training covers a range of topics essential for your CL and has an activity-driven structure. Additionally, the training includes tool demonstrations, which enhances its effectiveness.</p>
                    <div className="course-details">
                        <div className="inner-details">
                            <img src={process.env.PUBLIC_URL + "/images/Monarch/AMSEssential/Duration.png"} alt="duration-icon" className="duration-icon" />
                            <span>18 hours</span>
                        </div>
                        <div className="inner-details">
                            <img src={process.env.PUBLIC_URL + "/images/Monarch/AMS/virtual.png"} alt="self-paced icon" className="duration-icon" />
                            <span>Virtual instructor driven</span>
                        </div>
                    </div>

                    {readMore ? (
                        <>
                            <div className="horizontal-course-divider"></div>
                            <ul className="course-list">
                                <li>Course overview, Change & Service Request Management</li>
                                <li>Incident & Problem Management Overview, System Monitoring</li>
                                <li>Service Level Agreement (SLA) & Key Performance Indicators (KPI), A Day in the life of AM engineer</li>
                                <li>Ticketing Tool (ServiceNow) Overview </li>
                                <li>Major Incident Management (MIM)</li>
                            </ul>
                        </>
                    ) : ""
                    }
                    <p onClick={() => setReadMore(!readMore)} className="view-more">{readMore ? "View less ..." : "View more ..."}</p>
                </div>

                <div className="inner-box-container">
                    <img src={process.env.PUBLIC_URL + "/images/Monarch/AMS/PrimerClass.png"} alt="" className="tile-img" />
                    <img src={process.env.PUBLIC_URL + "/images/Monarch/AMS/week3.png"} alt="" className="week-img" />
                    <h3 className="course-heading two">AMS - Primer Class</h3>
                    <p className="course-desc">This course is designed to provide beginners with an overview of Application Maintenance Services (AMS) projects. It covers essential topics such as an AM overview, Incident and Problem Management, Change and Request Management, SLA and KPI, and System Monitoring. Additionally, the course includes practical illustrations of the roles and responsibilities of an AM Engineer in day-to-day life.</p>
                    <div className="course-details">
                        <div className="inner-details">
                            <img src={process.env.PUBLIC_URL + "/images/Monarch/AMSEssential/Duration.png"} alt="duration-icon" className="duration-icon" />
                            <span>18 hours</span>
                        </div>
                        <div className="inner-details">
                            <img src={process.env.PUBLIC_URL + "/images/Monarch/AMS/virtual.png"} alt="self-paced icon" className="duration-icon" />
                            <span>Virtual instructor driven</span>
                        </div>
                    </div>

                    {readMore2 ? (
                        <>
                            <div className="horizontal-course-divider"></div>
                            <ul className="course-list">
                                <li>Application Overview, AMS Project Life Cycle & SDLC</li>
                                <li>Waterfall & Agile Practices, Baseline of Application Maintenance</li>
                                <li>Resolve & Control Practices, Service Level Agreement (SLA) & Monitoring</li>
                                <li>Secured SDLC</li>
                                <li>Roles and Responsibilities of AM Engineer</li>

                            </ul>
                        </>
                    ) : ""
                    }
                    <p onClick={() => setReadMore2(!readMore2)} className="view-more">{readMore2 ? "View less ..." : "View more ..."}</p>
                </div>
            </div>
        </>
    );
}

export default AMS;
